import { faChevronLeft, faChevronRight, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { PaginationSkeleton } from './skeleton/PaginationSkeleton';

type PageNumberModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (pageNumber: number) => void;
};

const PageNumberModal: React.FC<PageNumberModalProps> = ({ isOpen, onClose, onSubmit }) => {
    const [pageNumber, setPageNumber] = useState("");

    const handleSubmit = () => {
        const page = parseInt(pageNumber);
        if (!isNaN(page)) {
            onSubmit(page);
        }
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-10 overflow-auto backdrop-blur">
            <div className="fixed inset-0 bg-purple-50 dark:bg-slate-800 fade-in " onClick={onClose}></div>
            <div className="bg-white dark:bg-dark-600 relative py-14 px-10 rounded-xl shadow-lg z-10 max-w-xs mx-4 w-full max-h-full overflow-y-auto bg-opacity-50 ">
                <button onClick={onClose} className='absolute right-0 top-0 p-5 text-2xl text-gray-300'><FontAwesomeIcon icon={faClose}></FontAwesomeIcon></button>
                <h2 className="text-lg font-semibold mb-4">Очих хуудсаа оруулна уу.</h2>
                <input
                    type="number"
                    value={pageNumber}
                    onChange={(e) => setPageNumber(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded mb-4 text-dark-700"
                />
                <div className="flex justify-end">
                    <button
                        onClick={handleSubmit}
                        className="bg-purple-500 text-white px-4 py-2 rounded"
                    >
                        Очих
                    </button>
                    
                </div>

            </div>
        </div>
    );
};

type PaginationProps = {
    currentPage:number;
    setCurrentPage:(pageNumber: number) => void;
    totalPages: number;
    onPageChange: (pageNumber: number) => void;
    isLoading?: boolean
};


const Pagination: React.FC<PaginationProps> = ({ currentPage, setCurrentPage, totalPages, onPageChange, isLoading=false }) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const goToPage = (page: number) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            onPageChange(page);
        }
    };

    const handleForward = () => {
        if (currentPage < totalPages) {
            goToPage(currentPage + 1);
        }
    };

    const handleBackward = () => {
        if (currentPage > 1) {
            goToPage(currentPage - 1);
        }
    };

    return (
        <>
        {isLoading?(<PaginationSkeleton></PaginationSkeleton>):(<div className="flex items-center justify-center space-x-2">
            <button
                onClick={handleBackward}
                disabled={currentPage === 1}
                className="rounded transition-transform duration-150 ease-in-out transform active:scale-95 bg-white dark:bg-dark-600 dark:text-dark-100 disabled:dark:text-dark-500 disabled:dark:border-dark-500  text-gray-800 px-3 py-2 border shadow-sm  text-xs disabled:border-gray-200 disabled:text-gray-200"
            >
                <FontAwesomeIcon icon={faChevronLeft}></FontAwesomeIcon>
            </button>

            <button
                onClick={() => setModalOpen(true)}
                className="rounded transition-transform duration-150 ease-in-out transform active:scale-95 bg-white dark:bg-dark-600 dark:text-dark-100 disabled:dark:text-dark-500 disabled:dark:border-dark-500 text-gray-800 px-3 py-2 border shadow-sm  text-xs font-bold"
            >
                {currentPage} / {totalPages}
            </button>

            <button
                onClick={handleForward}
                disabled={currentPage === totalPages}
                className="rounded transition-transform duration-150 ease-in-out transform active:scale-95 bg-white dark:bg-dark-600 dark:text-dark-100 disabled:dark:text-dark-500 disabled:dark:border-dark-500  text-gray-800 px-3 py-2 border shadow-sm  text-xs  disabled:border-gray-200 disabled:text-gray-200"
            >
                <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
            </button>

            
        </div>)}
        
        <PageNumberModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onSubmit={goToPage}
        /></>
        
    );
};

export default Pagination;